import { BaseApi } from './base';

class CRMApi extends BaseApi {
    constructor() {
        super('crm');
    }

    getTrialStatuses() {
        return this.get('/trial-statuses')
    }

    getTrials() {
        return this.get('/trials')
    }

    createTrial(trialData) {
        return this.post('/trial', trialData)
    }

    getUsers() {
        return this.get('/users')
    }

    getTrial(id) {
        return this.get(`/trial/${id}`)
    }

    updateTrial(data) {
        return this.post('/trial/change', data)
    }

    getBalances() {
        return this.get('/students')
    }

    getWebinars(data) {
        return this.post('/webinars', data)
    }

    getTransactions() {
        return this.get('/transactions');
    }

    setTeacherWorkingHours(data) {
        return this.post('/schedule', data)
    }

    getTeacherSchedule(id) {
        return this.get(`/schedule/${id}`)
    }

    getStudent(id) {
        return this.get(`/student/${id}`)
    }

    getStudentPayments(id) {
        return this.get(`/payments/${id}`)
    }

    transferMoney(data) {
        return this.post('/transfer', data)
    }

    getPrograms() {
        return this.get('/programs')
    }

    getGroups() {
        return this.get('/group')
    }

    setGroup(data) {
        return this.post('/group', data)
    }

    deleteGroup(id) {
        return this.get(`/group-delete/${id}`);
    }

    removeTrial(id) {
        return this.delete(`/trial/${id}`)
    }

}

export default new CRMApi();
